import React from "react";
import styled from "styled-components";
import Hero from "../components/homeComponents/Hero";
import Services from "../components/homeComponents/Services";
import About from "../components/homeComponents/About";
import Equipment from "../components/homeComponents/Equipment";
import Treatments from "../components/homeComponents/Treatments";
import Testimonials from "../components/homeComponents/Testimonials";
import Contact from "../components/homeComponents/Contact";
import Footer from "../components/homeComponents/Footer";

const Home = () => {
  return (
    <Container>
      <Hero />
      <Services />
      <About />
      <Equipment />
      <Treatments />
      {/* <Testimonials /> */}
      <Contact />
      <Footer />
    </Container>
  );
};

const Container = styled.div`
  padding: 0;
  /* overflow-x: hidden; */
`;

export default Home;
